module.exports = __webpack_public_path__ + "fonts/Inter-200-latin-ext34.ad4eb06.woff2";